/**
 * Reads `selectedProjectId` from the raw `getUser.uiState` JSON. Returns
 * undefined when `uiState` is absent, is not valid JSON, or is not an object.
 */
export const parseSelectedProjectId = (
  rawUiState: string | null | undefined,
): string | undefined => {
  if (!rawUiState) return undefined;
  try {
    const uiState = JSON.parse(rawUiState);
    if (typeof uiState !== "object" || uiState === null) return undefined;
    return (
      (uiState as { selectedProjectId?: string }).selectedProjectId ?? undefined
    );
  } catch {
    return undefined;
  }
};
